import React, { createContext } from "react";
import ProductsList from "../ProductsList";
import pu01 from "../images/products/pu0.1.jpg";
import pu02 from "../images/products/pu0.2.jpg";
import pu11 from "../images/products/pu1.1.jpg";
import pu12 from "../images/products/pu1.2.jpg";
import pu13 from "../images/products/pu1.3.jpg";
import pu14 from "../images/products/pu1.4.jpg";
import pu21 from "../images/products/pu2.1.jpg";
import pu22 from "../images/products/pu2.2.jpg";
import pu23 from "../images/products/pu2.3.jpg";
import pu24 from "../images/products/pu2.4.jpg";
import pu31 from "../images/products/pu3.1.jpg";
import pu32 from "../images/products/pu3.2.jpg";
import pu33 from "../images/products/pu3.3.jpg";
import pu34 from "../images/products/pu3.4.jpg";
import pu41 from "../images/products/pu4.1.jpg";
import pu42 from "../images/products/pu4.2.jpg";
import pu43 from "../images/products/pu4.3.jpg";
import pu44 from "../images/products/pu4.4.jpg";
import pu51 from "../images/products/pu5.1.jpg";
import pu52 from "../images/products/pu5.2.jpg";
import pu53 from "../images/products/pu5.3.jpg";
import pu54 from "../images/products/pu5.4.jpg";
import p11 from "../images/products/p1.1.jpg";
import p12 from "../images/products/p1.2.jpg";
import p13 from "../images/products/p1.3.jpg";
import p14 from "../images/products/p1.4.jpg";
import p21 from "../images/products/p2.1.jpg";
import p22 from "../images/products/p2.2.jpg";
import p31 from "../images/products/p3.1.jpg";
import p32 from "../images/products/p3.2.jpg";
import p33 from "../images/products/p3.3.jpg";
import p41 from "../images/products/p4.1.jpg";
import p42 from "../images/products/p4.2.jpg";
import p51 from "../images/products/p5.1.jpg";
import p52 from "../images/products/p5.2.jpg";
import p61 from "../images/products/p6.1.jpg";
import p62 from "../images/products/p6.2.jpg";
import p71 from "../images/products/p7.1.jpg";
import p72 from "../images/products/p7.2.jpg";
import p73 from "../images/products/p7.3.jpg";
import p81 from "../images/products/p8.1.jpg";
import p82 from "../images/products/p8.2.jpg";
import p83 from "../images/products/p8.3.jpg";
import p91 from "../images/products/p9.jpg";
import p101 from "../images/products/p10.1.jpg";
import p102 from "../images/products/p10.2.jpg";
import p103 from "../images/products/p10.3.jpg";
import p110 from "../images/products/p11.1.jpg";
import p111 from "../images/products/p11.2.jpg";
import p120 from "../images/products/p12.1.jpg";
import p121 from "../images/products/p12.2.jpg";
import p130 from "../images/products/p13.1.jpg";
import p131 from "../images/products/p13.2.jpg";
import p140 from "../images/products/p14.1.jpg";
import p141 from "../images/products/p14.2.jpg";
import p142 from "../images/products/p14.3.jpg";
import p150 from "../images/products/p15.1.jpg";
import p151 from "../images/products/p15.2.jpg";
import p160 from "../images/products/p16.jpg";
import pmain from "../images/products/main.jpg";
//
const productsData = [
  {
    name: " باتری یو پی اس صبا 12 ولت 9 آمپر (ناموجود)(Saba UPS 12V-9Ah)",
    slug: "battery-12v-18ah-saba-sealed-lead-acid-ups",
    image: [pu01, pu02],
    info: `
<h2>خرید و مشخصات باتری 12 ولت 9 آمپر صبا باتری</h2>
<p>باتری یو پی اس صبا باتری منبعی است که با تبدیل انرژی شیمیایی به انرژی الکتریکی، بین دو نقطه اختلاف پتانسیل الکتریکی ایجاد کرده و برق DC تولید می‌کند. این مدل با ولتاژ 12 ولت و ظرفیت 9 آمپر ساعت، یکی از پرفروش‌ترین محصولات در بازار برق و الکترونیک می‌باشد.</p>

<h3>کاربردهای باتری 12V-9Ah صبا باتری</h3>
<p>این باتری در تجهیزات متنوعی قابل استفاده است از جمله:</p>

<ul>
  <li>سیستم‌های یو پی اس</li>
  <li>لیفتراک و خودروهای برقی</li>
  <li>موتورهای برقی</li>
  <li>تابلوهای فرمان اساسنور</li>
  <li>ماشین‌های چمن‌زنی و گلف</li>
  <li>ویلچرهای برقی</li>
  <li>و سایر تجهیزات الکترونیکی</li>
</ul>

<h3>ویژگی‌های کلیدی</h3>
<p>باتری سیلد لید اسید (خشک) صبا باتری با مشخصات زیر ارائه می‌شود:</p>
<ul>
  <li>نیاز به نگهداری و افزودن آب مقطر ندارد</li>
  <li>طراحی مقاوم و پایدار</li>
  <li>عملکرد قابل اطمینان در شرایط مختلف</li>
  <li>طول عمر مناسب</li>
</ul>

<p>این محصول با ابعاد معمول برای باتری‌های 12 ولت 9 آمپر و وزن متناسب با آن، گزینه‌ای ایده‌آل برای مصارف صنعتی و تجاری است. برای خرید باتری 12 ولت 9 آمپر اصل با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه کنید.</p>`,
    price: 0,
    infos: `
<ul>
<li><strong>نوع:</strong> سیلد لید اسید (خشک)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 9 آمپر ساعت</li>
<li><strong>مقاومت داخلی:</strong> (حدود 25-30 میلی اهم برای 9 آمپر) میلی اهم</li>
<li><strong>ابعاد:</strong> (ابعاد معمول برای 12V-9Ah حدود 151x65x95 میلی‌متر) میلی‌متر</li>
<li><strong>وزن:</strong> (وزن معمول برای 12V-9Ah حدود 2.5-3 کیلوگرم) کیلوگرم</li>
<li><strong>تکنولوژی:</strong> باتری سیلد اسید یو پی اس</li>
<li><strong>گارانتی:</strong>6 ماه </li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
<li><strong>ولتاژ شارژ شناور:</strong> 13.38-13.68 ولت</li>
</ul>`,
    id: 1000,
    meta: {
      title: "خرید باتری 12 ولت 9 آمپر صبا باتری | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 12 ولت 9 آمپر صبا باتری مدل سیلد اسید UPS با کیفیت بالا و کاربردهای متنوع. قیمت روز و مشخصات فنی کامل.",
      keywords:
        "باتری 12 ولت 9 آمپر, باتری یو پی اس, باتری سیلد اسید, صبا باتری",
    },
  },
  {
    name: " باتری یو پی اس صبا 12 ولت 18 آمپر (ناموجود)(Saba UPS 12V-18Ah)",
    slug: "battery-12v-18ah-saba-sealed-lead-acid-ups",
    image: [pu11, pu12, pu13, pu14],
    info: `
<h2>خرید و مشخصات باتری 12 ولت 18 آمپر صبا باتری</h2>
<p>باتری یو پی اس صبا باتری منبعی است که با تبدیل انرژی شیمیایی به انرژی الکتریکی، بین دو نقطه اختلاف پتانسیل الکتریکی ایجاد کرده و برق DC تولید می‌کند. این مدل با ولتاژ 12 ولت و ظرفیت 18 آمپر ساعت، یکی از پرفروش‌ترین محصولات در بازار برق و الکترونیک می‌باشد.</p>

<h3>کاربردهای باتری 12V-18Ah صبا باتری</h3>
<p>این باتری در تجهیزات متنوعی قابل استفاده است از جمله:</p>

<ul>
  <li>سیستم‌های یو پی اس</li>
  <li>لیفتراک و خودروهای برقی</li>
  <li>موتورهای برقی</li>
  <li>تابلوهای فرمان اساسنور</li>
  <li>ماشین‌های چمن‌زنی و گلف</li>
  <li>ویلچرهای برقی</li>
  <li>و سایر تجهیزات الکترونیکی</li>
</ul>

<h3>ویژگی‌های کلیدی</h3>
<p>باتری سیلد لید اسید (خشک) صبا باتری با مشخصات زیر ارائه می‌شود:</p>
<ul>
  <li>نیاز به نگهداری و افزودن آب مقطر ندارد</li>
  <li>طراحی مقاوم و پایدار</li>
  <li>عملکرد قابل اطمینان در شرایط مختلف</li>
  <li>طول عمر مناسب</li>
</ul>

<p>این محصول با ابعاد 181×78×165 میلی‌متر و وزن 6.5 کیلوگرم، گزینه‌ای ایده‌آل برای مصارف صنعتی و تجاری است. برای خرید باتری 12 ولت 18 آمپر اصل با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه کنید.</p>`,
    price: 0,
    infos: `
<ul>
<li><strong>نوع:</strong> سیلد لید اسید (خشک)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 18 آمپر ساعت</li>
<li><strong>مقاومت داخلی:</strong> 20 میلی اهم</li>
<li><strong>ابعاد:</strong> 181×78×165 میلی‌متر</li>
<li><strong>وزن:</strong> 6.5 کیلوگرم</li>
<li><strong>تکنولوژی:</strong> باتری سیلد اسید یو پی اس</li>
<li><strong>گارانتی:</strong> فاقد گارانتی </li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
<li><strong>ولتاژ شارژ شناور:</strong> 13.38-13.68 ولت</li>
</ul>`,
    id: 1001,
    meta: {
      title: "خرید باتری 12 ولت 18 آمپر صبا باتری | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 12 ولت 18 آمپر صبا باتری مدل سیلد اسید UPS با کیفیت بالا و کاربردهای متنوع. قیمت روز و مشخصات فنی کامل.",
      keywords:
        "باتری 12 ولت 18 آمپر, باتری یو پی اس, باتری سیلد اسید, صبا باتری",
    },
  },
  {
    name: "باتری یو پی اس صبا 12 ولت 28 آمپر(Saba UPS 12V-28Ah)",
    slug: "battery-12v-28ah-saba-ups",
    image: [pu21, pu22, pu23, pu24],
    info: `
<h2>خرید و مشخصات باتری یو پی اس صبا 28 آمپر 12 ولت</h2>
<p>باتری یو پی اس صبا 28 آمپر 12 ولت با طراحی بدون نیاز به تعمیر و نگهداری، منبعی قابل اعتماد برای تأمین جریان الکتریکی در محیط‌های حساس می‌باشد. این محصول با مقاومت و پوشش ویژه، گزینه‌ای ایده‌آل برای مصارف صنعتی و تجاری است.</p>

<h3>کاربردهای باتری 28 آمپر صبا</h3>
<p>این باتری در سیستم‌های متنوعی قابل استفاده است از جمله:</p>

<ul>
  <li>سیستم‌های یو پی اس و سرورها</li>
  <li>چرخ‌دستی‌های گلف و ماشین‌آلات گلف</li>
  <li>ماشین‌های چمن‌زنی برقی</li>
  <li>خودروهای برقی سواری کودکان</li>
  <li>سیستم‌های روشنایی قابل حمل</li>
  <li>اسکوترهای برقی و وسایل نقلیه الکتریکی</li>
  <li>لیفتراک‌های برقی</li>
</ul>

<h3>مزایای کلیدی</h3>
<ul>
  <li>طراحی سیلد اسید (بدون نیاز به نگهداری)</li>
  <li>مقاومت بالا در برابر شرایط سخت کاری</li>
  <li>عملکرد پایدار و قابل اطمینان</li>
  <li>طول عمر بالا و دوام قابل توجه</li>
  <li>گارانتی 12 ماهه تعویض</li>
</ul>

<p>باتری یو پی اس صبا 28 آمپر با استفاده از جدیدترین تکنولوژی و مواد اولیه مرغوب تولید شده است. برای خرید این محصول با کیفیت و قیمت مناسب می‌توانید به باتری۱۰۰ مراجعه کنید.</p>`,
    price: 5545000,
    priceWithoutScrap: 7500000,
    infos: `
<ul>
<li><strong>نوع:</strong> سیلد اسید (خشک)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 28 آمپر ساعت</li>
<li><strong>ابعاد:</strong> استاندارد یو پی اس</li>
<li><strong>وزن:</strong> متناسب با ظرفیت</li>
<li><strong>گارانتی:</strong>12 ماه </li>
<li><strong>تکنولوژی:</strong> سیلد لید اسید</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
</ul>
`,
    id: 1002,
    meta: {
      title:
        "خرید باتری یو پی اس صبا 28 آمپر 12 ولت | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری یو پی اس صبا 28 آمپر 12 ولت با کیفیت بالا و گارانتی 12 ماهه، مناسب برای سیستم‌های حساس و صنعتی. قیمت روز و مشخصات فنی.",
      keywords:
        "باتری یو پی اس 28 آمپر, باتری 12 ولت صبا, باتری سیلد اسید, خرید باتری UPS",
    },
  },
  {
    name: "باتری یو پی اس صبا 12 ولت 42 آمپر(Saba UPS 12V-42Ah)",
    slug: "battery-42ah-saba-ups",
    image: [pu31, pu32, pu33, pu34],
    info: `
<h2>خرید و مشخصات باتری 42 آمپر یو پی اس صبا</h2>
<p>باتری 42 آمپر یو پی اس صبا به عنوان منبع پشتیبان اضطراری برق در سیستم‌های حیاتی کاربرد دارد. این محصول با کیفیت بالا و طراحی بهینه، گزینه‌ای ایده‌آل برای محافظت از تجهیزات الکترونیکی در برابر اختلالات برق می‌باشد.</p>

<h3>کاربردهای اصلی</h3>
<p>این باتری در صنایع و تجهیزات مختلفی استفاده می‌شود:</p>

<ul>
  <li>تجهیزات پزشکی حیاتی (مانیتورها، دستگاه‌های تنفس مصنوعی)</li>
  <li>دستگاه‌های تصویربرداری پزشکی (MRI، CT-Scan)</li>
  <li>سیستم‌های امنیتی و حفاظتی (دوربین‌های مداربسته، اعلام حریق)</li>
  <li>سیستم‌های صنعتی و تولیدی</li>
  <li>مراکز داده و سرورها</li>
</ul>

<h3>ویژگی‌های فنی برجسته</h3>
<p>مهم‌ترین مزایای این محصول شامل:</p>
<ul>
  <li>طراحی سرب-اسید مهر و موم شده (VRLA) بدون نیاز به نگهداری</li>
  <li>عملکرد عالی در بازیابی تخلیه عمیق</li>
  <li>خاصیت خود تخلیه پایین</li>
  <li>انعطاف پذیری در نصب با قابلیت قرارگیری در موقعیت‌های مختلف</li>
  <li>بهینه‌سازی شده برای استفاده با سیستم‌های یو پی اس</li>
</ul>

<p>این باتری با ابعاد 197×166×169 میلی‌متر و وزن 13.1 کیلوگرم، یکی از پرکاربردترین محصولات در صنایع مختلف محسوب می‌شود. برای خرید باتری 42 آمپر اصل با گارانتی معتبر صبا باتری، می‌توانید با کارشناسان ما تماس بگیرید.</p>`,
    price: 8635000,
    priceWithoutScrap: 12100000,
    infos: `
<ul>
<li><strong>نوع:</strong> سرب-اسید مهر و موم شده (VRLA)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 42 آمپر ساعت</li>
<li><strong>ابعاد:</strong> 197×166×169 میلی‌متر</li>
<li><strong>وزن:</strong> 13.1 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه</li>
<li><strong>کاربرد اصلی:</strong> سیستم‌های یو پی اس</li>
<li><strong>تکنولوژی:</strong> VRLL (شیر تنظیم)</li>

</ul>
`,
    id: 1003,
    meta: {
      title:
        "خرید باتری 42 آمپر یو پی اس صبا | قیمت با گارانتی 18 ماهه | باتری۱۰۰",
      description:
        "باتری 42 آمپر یو پی اس صبا با گارانتی 18 ماهه، مناسب برای تجهیزات پزشکی، سیستم‌های امنیتی و صنعتی. مشخصات فنی کامل و قیمت روز.",
      keywords:
        "باتری 42 آمپر, باتری یو پی اس, صبا باتری, باتری سیلد اسید, باتری 12 ولت",
    },
  },
  {
    name: "باتری یو پی اس صبا 12 ولت 65 آمپر(Saba UPS 12V-65Ah)",
    slug: "battery-12v-65ah-saba-ups",
    image: [pu41, pu42, pu43, pu44],
    info: `
<h2>خرید و مشخصات باتری یو پی اس 12 ولت 65 آمپر صبا باتری</h2>
<p>باتری یو پی اس 12 ولت 65 آمپر صبا باتری با تکنولوژی تولید به روز از نوع سیلد اسید، مناسب‌ترین گزینه برای اتصال به دستگاه‌های UPS می‌باشد. این محصول یک منبع انرژی جایگزین است که تضمین می‌کند در صورت اختلال در منبع انرژی شهری، انرژی مورد نیاز تجهیزات متصل برای مدت معینی تأمین شود.</p>

<h3>کاربردهای باتری 12V-65Ah صبا باتری</h3>
<p>این باتری در مکان‌های حیاتی و حساس استفاده می‌شود:</p>

<ul>
  <li>ادارات و شرکت‌ها (تجهیزات اداری و کامپیوتری)</li>
  <li>مراکز درمانی و بیمارستان‌ها (دستگاه‌های پزشکی)</li>
  <li>کارگاه‌ها و کارخانه‌ها (ماشین‌آلات صنعتی)</li>
  <li>منازل (سیستم‌های امنیتی و روشنایی اضطراری)</li>
  <li>مراکز بانکی و مالی</li>
</ul>

<h3>مزایای کلیدی</h3>
<p>باتری VRLA صبا باتری با مشخصات زیر ارائه می‌شود:</p>
<ul>
  <li>طراحی سیلد اسید مهر و موم شده (SLA) بدون نیاز به نگهداری)</li>
  <li>عملکرد قابل اطمینان در شرایط بحرانی</li>
  <li>طول عمر مناسب با نگهداری صحیح</li>
  <li>حفاظت از تجهیزات در برابر نوسانات برق</li>
  <li>سازگاری با انواع سیستم‌های یو پی اس</li>
</ul>

<h3>نکات نگهداری و افزایش عمر</h3>
<ul>
  <li>نگهداری در دمای مناسب (بین 20-25 درجه سانتیگراد)</li>
  <li>پرهیز از شارژ و دشارژ عمیق مکرر</li>
  <li>بررسی دوره‌ای وضعیت باتری</li>
  <li>عدم استفاده همزمان باتری‌های قدیمی و جدید در یک سیستم</li>
</ul>

<p>این محصول با گارانتی معتبر و خدمات پس از فروش قابل اطمینان ارائه می‌شود. برای خرید باتری 65 آمپر اصل با تاریخ تولید جدید می‌توانید به نمایندگی‌های معتبر مراجعه کنید.</p>`,
    price: 12390000,
    priceWithoutScrap: 18900000,
    infos: `
<ul>
<li><strong>نوع:</strong> سیلد اسید (VRLA)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 65 آمپر ساعت</li>
<li><strong>تکنولوژی:</strong> سرب-اسید مهر و موم شده</li>
<li><strong>کاربرد اصلی:</strong> سیستم‌های یو پی اس</li>
<li><strong>گارانتی:</strong> 12 ماه</li>
<li><strong>طول عمر مفید:</strong> 3-5 سال (با نگهداری مناسب)</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>

</ul>
`,
    id: 1004,
    meta: {
      title:
        "خرید باتری یو پی اس 12 ولت 65 آمپر صبا | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری یو پی اس 12 ولت 65 آمپر صبا باتری با تکنولوژی VRLA - مناسب برای سیستم‌های UPS اداری، صنعتی و پزشکی - قیمت روز و مشخصات فنی",
      keywords:
        "باتری 65 آمپر, باتری یو پی اس صبا, قیمت باتری 12 ولت, باتری سیلد اسید, باتری UPS",
    },
  },
  {
    name: " (ناموجود)باتری یو پی اس صبا12 ولت 100 آمپر( Saba UPS 12V-100Ah)",
    slug: "battery-12v-100ah-saba-ups",
    image: [pu51, pu52, pu53, pu54],
    info: `
<h2>خرید و مشخصات باتری 12 ولت 100 آمپر صبا باتری</h2>
<p>باتری یو پی اس ۱۲ ولت ۱۰۰ آمپر صبا باتری با ظرفیت بالا و قابلیت تأمین انرژی پایدار، یکی از بهترین گزینه‌ها برای سیستم‌های برق اضطراری می‌باشد. این محصول از نوع سیلد اسید بوده و نیاز به نگهداری خاصی ندارد.</p>

<h3>مزایای باتری ۱۰۰ آمپر یو پی اس صبا</h3>
<p>این باتری‌ها راه‌حلی ایده‌آل برای محیط‌های صنعتی و تجاری هستند:</p>

<ul>
  <li>ظرفیت بالا برای ذخیره انرژی بیشتر</li>
  <li>زمان پشتیبانی طولانی‌تر نسبت به مدل‌های کم‌ظرفیت</li>
  <li>قابلیت استفاده در کاربردهای متنوع (سرورها، سیستم‌های امنیتی و پزشکی)</li>
  <li>صرفه‌جویی اقتصادی در بلندمدت</li>
  <li>افزایش امنیت اطلاعات در مراکز داده</li>
  <li>شارژ و دشارژ سریع</li>
  <li>طراحی ایمن بدون خطر نشت مواد شیمیایی</li>
</ul>

<h3>کاربردهای اصلی</h3>
<p>این باتری در سیستم‌های مختلفی قابل استفاده است:</p>
<ul>
  <li>دیتاسنترها و سرورها</li>
  <li>سیستم‌های امنیتی و دوربین‌های مداربسته</li>
  <li>تجهیزات پزشکی و بیمارستانی</li>
  <li>سیستم‌های مخابراتی</li>
  <li>تجهیزات صنعتی</li>
</ul>

<p>باتری 100 آمپر صبا با طراحی مقاوم و عملکرد قابل اطمینان، گزینه‌ای ایده‌آل برای مصارف حساس و صنعتی می‌باشد. برای خرید باتری 12 ولت 100 آمپر اصل با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه کنید.</p>`,
    price: 0,
    infos: `
<ul>
<li><strong>نوع:</strong> سیلد اسید (خشک)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 100 آمپر ساعت</li>
<li><strong>ابعاد:</strong> [ابعاد را اضافه کنید]</li>
<li><strong>وزن:</strong> [وزن را اضافه کنید]</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
<li><strong>گارانتی:</strong> 18 ماه</li>
<li><strong>ولتاژ شارژ شناور:</strong> [مقدار ولتاژ]</li>
<li><strong>مقاومت داخلی:</strong> [مقدار مقاومت]</li>
</ul>`,
    id: 1005,
    meta: {
      title:
        "خرید باتری 12 ولت 100 آمپر صبا باتری | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری یو پی اس 12 ولت 100 آمپر صبا باتری با ظرفیت بالا و کارایی عالی برای سیستم‌های صنعتی. قیمت روز و مشخصات فنی کامل.",
      keywords:
        "باتری 100 آمپر, باتری یو پی اس صبا, باتری 12 ولت, باتری سیلد اسید",
    },
  },
  {
    name: "باتری واریان صبا 50 آمپر ال 1(ناموجود)(Varian 50 L1)",
    slug: "battery-50ah-saba-varian-l1",
    image: [p11, p12, p13, p14],
    info: `
    <h2>خرید و قیمت باتری 50 آمپر صبا واریان L1</h2>
    <p>باتری خودرو 50 آمپر واریان L1 تولید شرکت صبا باتری، یکی از باکیفیت‌ترین محصولات در رده باتری‌های اتمی سیلد است. این مدل با طراحی پیشرفته و تکنولوژی روز، گزینه‌ای ایده‌آل برای خودروهای شهری و سبک محسوب می‌شود.</p>

    <h3>چرا باتری واریان 50 آمپر را انتخاب کنیم؟</h3>
    <p>مدل L1 باتری واریان با آمپر 50 و ولتاژ 12، محصولی کاملاً بهینه برای استفاده در شرایط مختلف جاده‌ای است. از مهم‌ترین مزایای این محصول می‌توان به موارد زیر اشاره کرد:</p>
    
    <ul>
      <li>طراحی اتمی سیلد (بدون نیاز به نگهداری و افزودن آب مقطر)</li>
      <li>مقاومت استثنایی در برابر لرزش‌های مداوم خودرو</li>
      <li>عملکرد عالی در دمای پایین (استارت‌زنی قوی در هوای سرد)</li>
      <li>سیستم فیلتراسیون ضد انفجار برای ایمنی بیشتر</li>
      <li>طول عمر بالا و دوام قابل توجه</li>
    </ul>

    <h3>مشخصات فنی باتری 50 آمپر</h3>
    <p>این مدل از باتری خودرو با ابعاد 207×175×190 میلی‌متر و وزن 12.7 کیلوگرم، به‌راحتی در محفظه باتری خودروهای سبک جای می‌گیرد. گارانتی 12 ماهه شرکت صبا باتری، نشان‌دهنده اعتماد سازنده به کیفیت این محصول است.</p>

    <p>باتری واریان 50 آمپر برای خودروهای تیبا، پراید، پژو 206، پژو 207، رانا، هایوندای i20، کوییک و ساینا انتخاب مناسبی است. قیمت این محصول با توجه به کیفیت ساخت و خدمات پس از فروش، کاملاً اقتصادی و مقرون‌به‌صرفه می‌باشد.</p>

    <p>برای خرید باتری 50 آمپر اصل با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه کنید. کارشناسان ما آماده ارائه مشاوره تخصصی برای انتخاب بهترین باتری متناسب با نیاز خودروی شما هستند.</p>
  `,
    price: 2375000,
    infos: `
    <ul>
      <li><strong>نوع:</strong> اتمی سیلد (MF)</li>
      <li><strong>آمپر ساعت:</strong> 50Ah</li>
      <li><strong>ولتاژ:</strong> 12 ولت</li>
      <li><strong>ابعاد:</strong> 207×175×190 میلی‌متر</li>
      <li><strong>وزن:</strong> 12.7 کیلوگرم</li>
      <li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
      <li><strong>سازنده:</strong> شرکت صبا باتری</li>
    </ul>
  `,
    id: 1006,
    meta: {
      title: "خرید باتری 50 آمپر واریان L1 | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 50 آمپر صبا واریان L1 با گارانتی 12 ماهه، مناسب خودروهای شهری و سبک. قیمت روز و مشخصات فنی کامل.",
      keywords: "باتری 50 آمپر, قیمت باتری واریان, باتری صبا, باتری خودرو",
    },
  },
  {
    name: "باتری واریان صبا 50 آمپر ال2(ناموجود)(Varian 50 L2) ",
    slug: "battery-50ah-saba-varian-l2",
    image: [p21, p22],
    info: `<h2>خرید و قیمت باتری 50 آمپر صبا واریان L2</h2>
<p>باتری خودرو 50 آمپر واریان L2 از تولیدات باکیفیت شرکت صبا باتری است که با قیمت مناسب و گارانتی 12 ماهه عرضه می‌شود. این محصول با تکنولوژی روز دنیا تولید شده و گزینه‌ای ایده‌آل برای خودروهای سبک شهری محسوب می‌شود.</p>

<h3>مزایای کلیدی باتری واریان L2</h3>
<p>مدل L2 باتری واریان با آمپر 50 و ولتاژ 12 ولت، محصولی کارآمد برای استفاده در شرایط مختلف رانندگی است. مهم‌ترین ویژگی‌های این محصول عبارتند از:</p>

<ul>
  <li>طراحی اتمی سیلد بدون نیاز به نگهداری</li>
  <li>مقاومت فوق‌العاده در برابر لرزش و ضربه</li>
  <li>عملکرد مطلوب در دمای پایین (استارت‌زنی سریع در هوای سرد)</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر طولانی و بازدهی بالا</li>
</ul>

<h3>ویژگی‌های فنی محصول</h3>
<p>این مدل باتری با ابعاد 242×175×190 میلی‌متر و وزن 13.8 کیلوگرم، به‌راحتی در محفظه باتری خودروهای سبک نصب می‌شود. گارانتی 12 ماهه شرکت صبا باتری نشانه اطمینان از کیفیت ساخت این محصول است.</p>

<p>باتری واریان 50 آمپر L2 برای خودروهای تیبا، پراید، پژو 206، پژو 207، رانا، هایوندای i20، کوییک و ساینا مناسب است. قیمت این محصول با در نظر گرفتن کیفیت و خدمات پس از فروش، کاملاً اقتصادی و به صرفه می‌باشد.</p>

<p>برای خرید باتری 50 آمپر واریان L2 با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه راهنمایی تخصصی برای انتخاب بهترین باتری متناسب با خودروی شما هستند.</p>`,
    price: 2380000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 50Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 242×175×190 میلی‌متر</li>
<li><strong>وزن:</strong> 13.8 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
</ul>`,
    id: 1007,
    meta: {
      title: "خرید باتری 50 آمپر واریان L2 | قیمت ویژه با گارانتی | باتری۱۰۰",
      description:
        "باتری 50 آمپر واریان L2 با طراحی اتمی سیلد، گارانتی 12 ماهه و قیمت مناسب برای خودروهای سبک شهری. مناسب پژو 206 و 207.",
      keywords:
        "باتری 50 آمپر, باتری واریان L2, باتری پژو 206, قیمت باتری خودرو, باتری اتمی",
    },
  },
  {
    name: " باتری واریان صبا 55 آمپر (ناموجود)(Varian 55) ",
    slug: "battery-55ah-saba-varian",

    image: [p31, p32, p33],
    info: `<h2>خرید و قیمت باتری 55 آمپر صبا واریان L2</h2>
<p>باتری خودرو 55 آمپر واریان L2 از تولیدات باکیفیت شرکت صبا باتری است که با طراحی اتمی سیلد و گارانتی 12 ماهه عرضه می‌شود. این محصول با ابعاد بهینه و وزن مناسب، گزینه‌ای ایده‌آل برای خودروهای پراید، پژو 206، تیبا و هیوندای ورنا می‌باشد.</p>

<h3>ویژگی‌های منحصر به فرد</h3>
<p>باتری واریان 55 آمپر L2 با تکنولوژی پیشرفته تولید شده و مزایای زیر را ارائه می‌دهد:</p>

<ul>
  <li>طراحی سیلد (خشک) بدون نیاز به نگهداری</li>
  <li>مقاومت استثنایی در برابر لرزش و ضربات جاده‌ای</li>
  <li>عملکرد عالی در دمای پایین (استارت‌زنی سریع تا -30 درجه)</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر طولانی با حداقل افت شارژ در حالت سکون</li>
</ul>

<h3>مشخصات فنی</h3>
<p>این مدل باتری با ابعاد 240×175×190 میلی‌متر و وزن 16.5 کیلوگرم، به‌راحتی در محفظه باتری خودروهای سبک نصب می‌شود. ولتاژ 12 ولت و آمپر 55Ah این محصول، نیاز خودروهای شهری را به‌طور کامل برطرف می‌کند.</p>

<p>قیمت باتری 55 آمپر صبا با توجه به کیفیت ساخت و خدمات پس از فروش، کاملاً اقتصادی بوده و با خرید از باتری۱۰۰ از نصب رایگان و خدمات امداد خودرو در تهران بهره‌مند خواهید شد.</p>

<h3>تأثیر دما بر عملکرد باتری</h3>
<p>باتری واریان 55 آمپر برای عملکرد در شرایط آب‌وهوایی مختلف طراحی شده است. در دمای پایین، سیستم شیمیایی بهینه‌شده آن امکان استارت‌زنی سریع را فراهم می‌کند. در دمای بالا نیز با استفاده از مواد مقاوم، از تبخیر الکترولیت جلوگیری می‌کند.</p>

<p>برای افزایش عمر باتری توصیه می‌شود:</p>
<ul>
  <li>پایانه‌ها را ماهانه تمیز کنید</li>
  <li>از خالی ماندن طولانی‌مدت باتری جلوگیری کنید</li>
  <li>در صورت عدم استفاده طولانی، باتری را شارژ نگه دارید</li>
</ul>`,
    price: 2650000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (خشک)</li>
<li><strong>آمپر ساعت:</strong> 55Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 240×175×190 میلی‌متر</li>
<li><strong>وزن:</strong> 16.5 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری </li>
<li><strong>خودروهای سازگار:</strong> پراید، پژو 206، تیبا، هیوندای ورنا</li>
</ul>`,
    id: 1008,
    meta: {
      title: "باتری 55 آمپر واریان | قیمت روز با گارانتی معتبر | باتری۱۰۰",
      description:
        "باتری 55 آمپر واریان با قدرت استارت‌زنی بالا، مناسب خودروهای پراید، تیبا، پژو 206 و هیوندای ورنا. گارانتی 12 ماهه صبا باتری.",
      keywords:
        "باتری 55 آمپر, باتری پراید, باتری تیبا, قیمت باتری واریان, باتری اتمی سیلد",
    },
  },
  {
    name: "باتری واریان صبا 60 آمپر پایه کوتاه (ناموجود)(Varian 60)",
    slug: "battery-60ah-saba-varian-short",
    image: [p41, p42],
    info: `<h2>خرید و قیمت باتری 60 آمپر واریان کوتاه</h2>
<p>باتری خودرو 60 آمپر واریان کوتاه از تولیدات با کیفیت شرکت سپاهان باتری است که با طراحی ویژه برای خودروهای سبک تولید شده است. این محصول با قیمت مناسب و گارانتی معتبر، انتخاب بسیاری از رانندگان آگاه می‌باشد.</p>

<h3>مزایای باتری واریان 60 آمپر کوتاه</h3>
<p>این مدل باتری با تکنولوژی روز و مواد اولیه مرغوب تولید شده و دارای ویژگی‌های منحصر به فردی است:</p>

<ul>
  <li>طراحی کوتاه و مناسب برای خودروهای سبک</li>
  <li>استارت‌زنی قوی حتی در دمای پایین</li>
  <li>مقاومت بالا در برابر لرزش و ضربه</li>
  <li>عمر طولانی و عملکرد پایدار</li>
  <li>سیستم ایمنی پیشرفته</li>
  <li>قیمت مناسب نسبت به نمونه‌های خارجی</li>
</ul>

<h3>مشخصات فنی</h3>
<p>باتری واریان 60 آمپر کوتاه با ابعاد استاندارد و وزن مناسب طراحی شده است:</p>

<ul>
  <li><strong>نوع:</strong> اسیدی-سربی</li>
  <li><strong>ظرفیت:</strong> 60 آمپر ساعت</li>
  <li><strong>ولتاژ:</strong> 12 ولت</li>
  <li><strong>ابعاد:</strong> استاندارد کوتاه</li>
  <li><strong>گارانتی:</strong> معتبر شرکتی</li>
</ul>

<h3>خودروهای سازگار</h3>
<p>این مدل باتری برای خودروهای زیر مناسب است:</p>
<ul>
  <li>پژو 206 و 405</li>
  <li>سمند و سمند LX</li>
  <li>پراید و تیبا</li>
  <li>رانا و ال 90 (لوگان)</li>
</ul>

<h3>نکات مهم خرید</h3>
<p>برای خرید باتری واریان 60 آمپر کوتاه به این موارد توجه کنید:</p>
<ul>
  <li>تاریخ تولید جدید</li>
  <li>گارانتی معتبر</li>
  <li>فروشگاه‌های معتبر</li>
  <li>مقایسه قیمت</li>
</ul>

<p>برای اطلاع از قیمت دقیق و خرید مطمئن باتری واریان 60 آمپر کوتاه، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره رایگان هستند.</p>`,
    price: 2800000,
    infos: `<ul>
<li><strong>برند:</strong> واریان (شرکت سپاهان باتری)</li>
<li><strong>نوع:</strong> اسیدی-سربی</li>
<li><strong>ظرفیت:</strong> 60 آمپر ساعت</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> استاندارد کوتاه</li>
<li><strong>گارانتی:</strong> معتبر شرکتی</li>
<li><strong>ویژگی‌ها:</strong> مقاوم در برابر لرزش، عملکرد عالی در دمای پایین</li>
</ul>`,
    id: 1009,
    meta: {
      title: "خرید باتری 60 آمپر واریان کوتاه | قیمت با تخفیف ویژه | باتری۱۰۰",
      description:
        "باتری 60 آمپر واریان کوتاه با طراحی فشرده، مناسب خودروهای پژو 405، سمند و رانا. گارانتی 12 ماهه و قیمت رقابتی.",
      keywords:
        "باتری 60 آمپر, باتری کوتاه, باتری پژو 405, باتری سمند, قیمت باتری خودرو",
    },
  },
  {
    name: " باتری واریان صبا 60 آمپر پایه بلند (ناموجود)(Varian 60) ",
    slug: "battery-60ah-saba-varian-long",
    image: [p51, p52],
    info: `<h2>خرید و قیمت باتری 60 آمپر صبا واریان پایه بلند</h2>
<p>باتری 60 آمپر واریان پایه بلند از تولیدات باکیفیت شرکت صبا باتری است که با تکنولوژی پیشرفته سیلد (اتمی) تولید شده است. این محصول با گارانتی 12 ماهه و قیمت مناسب، گزینه‌ای ایده‌آل برای خودروهای متوسط و سنگین محسوب می‌شود.</p>

<h3>مزایای باتری واریان 60 آمپر پایه بلند</h3>
<p>این مدل باتری با طراحی ویژه پایه بلند، مزایای متعددی برای خودروهای مختلف دارد:</p>

<ul>
  <li>طراحی اتمی سیلد بدون نیاز به نگهداری</li>
  <li>مقاومت فوق‌العاده در برابر لرزش و ضربه</li>
  <li>عملکرد مطلوب در دمای پایین (استارت‌زنی قوی در هوای سرد)</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر طولانی و بازدهی بالا</li>
  <li>مناسب برای خودروهای با مصرف برق بالا</li>
</ul>

<h3>ویژگی‌های فنی</h3>
<p>باتری واریان 60 آمپر پایه بلند با ابعاد 227×175×242 میلی‌متر و وزن 16.9 کیلوگرم، برای خودروهای زیر مناسب است:</p>
<ul>
  <li>سراتو</li>
  <li>وراکروز</li>
  <li>آزرا</li>
  <li>کمری</li>
  <li>و دیگر خودروهای متوسط و سنگین</li>
</ul>

<h3>نکات مهم در استفاده و نگهداری</h3>
<p>برای افزایش عمر باتری واریان 60 آمپر رعایت این نکات ضروری است:</p>
<ul>
  <li>از شارژ بیش از حد باتری خودداری کنید</li>
  <li>سیستم برق خودرو را به طور دوره‌ای بررسی نمایید</li>
  <li>در صورت عدم استفاده طولانی مدت، باتری را از خودرو جدا کنید</li>
  <li>برای نصب و تعویض باتری از متخصصین کمک بگیرید</li>
</ul>

<p>قیمت این باتری با توجه به کیفیت ساخت و گارانتی معتبر آن، کاملاً اقتصادی و مقرون‌به‌صرفه است. برای خرید باتری 60 آمپر واریان پایه بلند با گارانتی اصلی، می‌توانید به باتری۱۰۰ مراجعه نمایید.</p>`,
    price: 2870000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (خشک)</li>
<li><strong>آمپر ساعت:</strong> 60Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 227×175×242 میلی‌متر (طول×عرض×ارتفاع)</li>
<li><strong>وزن:</strong> 16.9 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری </li>
</ul>`,
    id: 1010,
    meta: {
      title: "باتری 60 آمپر واریان پایه بلند | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 60 آمپر واریان پایه بلند مناسب خودروهای سراتو، وراکروز و آزرا. مقاوم در برابر لرزش با گارانتی 12 ماهه.",
      keywords:
        "باتری 60 آمپر, باتری پایه بلند, باتری سراتو, باتری وراکروز, قیمت باتری خودرو",
    },
  },
  {
    name: "باتری واریان صبا 60 آمپر پایه بلند قطب معکوس (ناموجود)(Varian 60 Reverse) ",
    slug: "battery-60ah-saba-varian-reverse",
    image: [p61, p62],
    info: `<h2>خرید و قیمت باتری 60 آمپر واریان صبا (قطب معکوس)</h2>
<p>باتری 60 آمپر واریان صبا با تیپ FX و قطبیت معکوس (مثبت چپ - منفی راست)، یکی از باکیفیت‌ترین محصولات شرکت صبا باتری برای خودروهای خاص است. این محصول با تکنولوژی پیشرفته و گارانتی 12 ماهه، انتخاب مطمئنی برای رانندگان حرفه‌ای محسوب می‌شود.</p>

<h3>ویژگی‌های منحصر به فرد باتری واریان 60 آمپر</h3>
<p>این مدل از باتری خودرو با مشخصات فنی ویژه، پاسخگوی نیاز خودروهای با طراحی خاص است:</p>

<ul>
  <li>طراحی قطب معکوس (مثبت چپ - منفی راست) برای خودروهای ویژه</li>
  <li>جریان راه‌اندازی سرد 500 آمپر (CCA-EN-500) برای استارت سریع</li>
  <li>آلیاژ سرب کلسیم برای عمر طولانی‌تر</li>
  <li>الکترولیت اسید سولفوریک با کیفیت بالا</li>
  <li>مقاومت استثنایی در برابر شارژ و دشارژهای مکرر</li>
</ul>

<h3>مشخصات فنی و گارانتی</h3>
<p>باتری واریان 60 آمپر با ابعاد 242×175×190 میلی‌متر، مناسب برای خودروهای با فضای محدود است. گارانتی 12 ماهه تعویض این محصول، نشانه اطمینان سازنده از کیفیت بالای آن می‌باشد.</p>

<p>این مدل باتری با ظرفیت 60 آمپر ساعت و ولتاژ 12 ولت، برای خودروهای با سیستم الکتریکی پیشرفته کاملاً مناسب است. قیمت این محصول با توجه به ویژگی‌های خاص و گارانتی طولانی مدت، کاملاً اقتصادی و منطقی می‌باشد.</p>

<p>برای خرید باتری 60 آمپر واریان صبا با قطب معکوس و گارانتی معتبر 12 ماهه، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان فنی ما آماده ارائه مشاوره تخصصی برای انتخاب بهترین گزینه هستند.</p>
`,
    price: 2870000,
    infos: `<ul>
<li><strong>نام تجاری:</strong> VARIAN</li>
<li><strong>تیپ باتری:</strong> FX</li>
<li><strong>نوع:</strong> استارتر</li>
<li><strong>ظرفیت:</strong> 60 آمپر ساعت</li>
<li><strong>قطبیت:</strong> مثبت چپ - منفی راست</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>جریان راه‌اندازی سرد:</strong> CCA-EN-500</li>
<li><strong>گارانتی:</strong> 12 ماه تعویض</li>
<li><strong>ابعاد:</strong> 242×175×190 میلی‌متر</li>
<li><strong>آلیاژ سرب:</strong> کلسیم</li>
<li><strong>الکترولیت:</strong> اسید سولفوریک و آب مقطر</li>
</ul>`,
    id: 1011,
    meta: {
      title: "خرید باتری 60 آمپر واریان قطب معکوس | قیمت استثنایی | باتری۱۰۰",
      description:
        "باتری 60 آمپر واریان با قطبیت معکوس (مثبت چپ) برای خودروهای خاص. گارانتی 12 ماهه و کیفیت تضمینی.",
      keywords:
        "باتری قطب معکوس, باتری 60 آمپر, باتری خودروهای خاص, قیمت باتری واریان",
    },
  },
  {
    name: "باتری واریان صبا 66 آمپر (ناموجود)(Varian 66)",
    slug: "battery-66ah-saba-varian-l3",
    image: [p71, p72, p73],
    info: `<h2>خرید و قیمت باتری 66 آمپر صبا واریان L3</h2>
<p>باتری 66 آمپر واریان L3 از تولیدات باکیفیت شرکت صبا باتری با کد MF56601 است که با قدرت جریان لحظه‌ای 450 CCA، یکی از پرطرفدارترین باتری‌های ایرانی محسوب می‌شود. این محصول با تکنولوژی MF (اتمی خشک) تولید شده و گزینه‌ای ایده‌آل برای خودروهای متوسط است.</p>

<h3>ویژگی‌های منحصر به فرد باتری واریان 66 آمپر</h3>
<p>مدل L3 باتری واریان با آمپر 66 و ولتاژ 12 ولت، محصولی پرتوان برای خودروهای سنگین‌تر شهری است. مهم‌ترین مزایای این محصول عبارتند از:</p>

<ul>
  <li>طراحی اتمی سیلد (MF) بدون نیاز به نگهداری</li>
  <li>قدرت استارت‌زنی بالا با 450 آمپر CCA</li>
  <li>مقاومت استثنایی در برابر لرزش و ضربه</li>
  <li>عملکرد مطلوب در دمای پایین و شرایط سخت</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر طولانی تا 40 هزار کیلومتر</li>
</ul>

<h3>مشخصات فنی و ابعاد</h3>
<p>این مدل باتری با ابعاد 276×175×190 میلی‌متر و وزن 17.5 کیلوگرم (با الکترولیت) طراحی شده است. گارانتی 12 ماهه شرکت صبا باتری همراه با کارت گارانتی رسمی ارائه می‌شود.</p>

<h3>خودروهای سازگار</h3>
<p>باتری واریان 66 آمپر L3 برای خودروهای زیر مناسب است:</p>
<ul>
  <li>سمند و سمند LX</li>
  <li>رانا</li>
  <li>پژو پارس و پرشیا</li>
  <li>ال 90</li>
  <li>جک S5</li>
</ul>

<p>قیمت این باتری با توجه به کیفیت ساخت و گارانتی معتبر، کاملاً اقتصادی و به صرفه می‌باشد. برای خرید باتری 66 آمپر واریان L3 با گارانتی اصلی، می‌توانید به باتری۱۰۰ مراجعه نمایید.</p>`,
    price: 3050000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 66Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>CCA:</strong> 450 آمپر</li>
<li><strong>ابعاد:</strong> 276×175×190 میلی‌متر</li>
<li><strong>وزن:</strong> 17.5 کیلوگرم (با الکترولیت)</li>
<li><strong>وزن خشک:</strong> 12 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>کد محصول:</strong> MF56601</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
</ul>`,
    id: 1012,
    meta: {
      title: "باتری 66 آمپر واریان L3 | قیمت با گارانتی 12 ماهه | باتری۱۰۰",
      description:
        "باتری 66 آمپر واریان L3 با قدرت استارت‌زنی 450 آمپر، مناسب سمند، رانا و پژو پارس. مقاوم در برابر لرزش.",
      keywords:
        "باتری 66 آمپر, باتری سمند, باتری رانا, قیمت باتری خودرو, باتری اتمی",
    },
  },
  {
    name: " باتری واریان صبا 70 آمپر پایه بلند (ناموجود)(Varian 70) ",
    slug: "battery-70ah-saba-varian-long",

    image: [p81, p82, p83],
    info: `<h2>خرید و قیمت باتری 70 آمپر واریان پایه بلند</h2>
<p>باتری 70 آمپر واریان پایه بلند از تولیدات باکیفیت شرکت صبا باتری است که با تکنولوژی روز دنیا تولید می‌شود. این محصول با طراحی اتمی سیلد (MF) و گارانتی 12 ماهه، گزینه‌ای ایده‌آل برای خودروهای متوسط و سنگین محسوب می‌شود.</p>

<h3>ویژگی‌های منحصر به فرد</h3>
<p>باتری واریان 70 آمپر پایه بلند با مشخصات فنی پیشرفته تولید شده است:</p>

<ul>
  <li>طراحی اتمی سیلد بدون نیاز به نگهداری</li>
  <li>مقاومت فوق‌العاده در برابر لرزش و ضربه</li>
  <li>عملکرد مطلوب در دمای پایین (استارت‌زنی قوی در هوای سرد)</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر طولانی و بازدهی بالا</li>
</ul>

<h3>مشخصات فنی</h3>
<p>این مدل باتری با ابعاد 225×176×257 میلی‌متر و وزن مناسب، به‌راحتی در محفظه باتری خودروهای متوسط و سنگین نصب می‌شود. گارانتی 12 ماهه شرکت صبا باتری نشانه اطمینان از کیفیت ساخت این محصول است.</p>

<p>باتری واریان 70 آمپر پایه بلند برای خودروهای سوزوکی ویتارا، رنو مگان، نیسان رونیز، نیسان پاترول، پاژن و مزدا وانت مناسب است. قیمت این محصول با در نظر گرفتن کیفیت و خدمات پس از فروش، کاملاً اقتصادی و به صرفه می‌باشد.</p>

<p>برای خرید باتری 70 آمپر واریان پایه بلند با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره تخصصی برای انتخاب بهترین باتری متناسب با خودروی شما هستند.</p>`,
    price: 3100000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 70Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 225×176×257 میلی‌متر</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
<li><strong>ویژگی‌های خاص:</strong> مقاوم در برابر لرزش، عملکرد عالی در دمای پایین</li>
</ul>`,
    id: 1013,
    meta: {
      title: "خرید باتری 70 آمپر واریان پایه بلند | قیمت ویژه | باتری۱۰۰",
      description:
        "باتری 70 آمپر واریان پایه بلند مناسب خودروهای سوزوکی ویتارا، رنو مگان و نیسان پاترول. گارانتی 12 ماهه.",
      keywords:
        "باتری 70 آمپر, باتری پایه بلند, باتری ویتارا, باتری پاترول, قیمت باتری خودرو",
    },
  },
  {
    name: "باتری واریان صبا 70 آمپر پایه بلند قطب معکوس (ناموجود)(Varian 70 Reverse) ",
    slug: "battery-70ah-saba-varian-reverse",

    image: [p91],
    info: `<h2>خرید و قیمت باتری 70 آمپر واریان صبا (پایه بلند قطب معکوس)</h2>
<p>باتری 70 آمپر واریان با پایه بلند و قطب معکوس، یکی از پرطرفدارترین محصولات شرکت صبا باتری است که با قیمت مناسب و کیفیت مطلوب، گزینه‌ای ایده‌آل برای بسیاری از خودروهای سواری محسوب می‌شود.</p>

<h3>ویژگی‌های منحصر به فرد باتری واریان 70 آمپر</h3>
<p>این مدل از باتری‌های صبا باتری با تکنولوژی روز و استانداردهای جهانی تولید شده و مزایای زیر را ارائه می‌دهد:</p>

<ul>
  <li>طراحی اتمی سیلد بدون نیاز به نگهداری</li>
  <li>پایه بلند و قطب‌بندی معکوس مناسب خودروهای خاص</li>
  <li>مقاومت عالی در برابر لرزش و ضربه</li>
  <li>عملکرد مطلوب در دمای پایین (استارت‌زنی قوی در هوای سرد)</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>طول عمر بالا و بازدهی مطلوب</li>
  <li>گارانتی 12 ماهه شرکت معتبر صبا باتری</li>
</ul>

<h3>مشخصات فنی و کاربردها</h3>
<p>باتری واریان 70 آمپر معکوس با ابعاد مناسب و طراحی پایه بلند، برای خودروهای زیر ایده‌آل است:</p>
<ul>
  <li>هیوندایی (سانتافه، آزرا، توسان، سوناتا، النترا، i40)</li>
  <li>کیا (اپتیما، اسپورتیج، کادنزا)</li>
  <li>تویوتا (کمری، رفور)</li>
  <li>نیسان (ماکسیما)</li>
  <li>مزدا 3</li>
  <li>وراکروز</li>
  <li>پیکاپ‌های سبک</li>
</ul>

<p>این باتری با وجود ظرفیت 70 آمپر، برای خودروهایی که سیستم برقی سنگین ندارند کاملاً مناسب است. قیمت باتری واریان 70 آمپر معکوس با توجه به کیفیت ساخت و خدمات پس از فروش، بسیار مقرون‌به‌صرفه می‌باشد.</p>

<p>برای خرید باتری 70 آمپر واریان با گارانتی معتبر و خدمات نصب رایگان، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره تخصصی هستند.</p>`,
    price: 3100000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 70Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>قطب‌بندی:</strong> معکوس (پایه بلند)</li>
<li><strong>ابعاد:</strong> مناسب خودروهای خاص</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
</ul>`,
    id: 1014,
    meta: {
      title: "باتری 70 آمپر واریان قطب معکوس | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 70 آمپر واریان با پایه بلند و قطب معکوس، مناسب هیوندایی سانتافه، آزرا و توسان. کیفیت تضمینی.",
      keywords:
        "باتری 70 آمپر, باتری قطب معکوس, باتری هیوندایی, باتری سانتافه, قیمت باتری خودرو",
    },
  },
  {
    name: "باتری واریان صبا 74 آمپر (ناموجود)(Varian 74) ",
    slug: "battery-74ah-saba-varian",
    image: [p101, p102, p103],
    info: `<h2>خرید و قیمت باتری 74 آمپر صبا واریان</h2>
<p>باتری 74 آمپر واریان سیلد از محصولات پرفروش و باکیفیت شرکت صبا باتری است که با قیمت مناسب و گارانتی معتبر عرضه می‌شود. این باتری اتمی با تکنولوژی روز دنیا تولید شده و گزینه‌ای ایده‌آل برای خودروهای متوسط و نیمه‌سنگین محسوب می‌شود.</p>

<h3>ویژگی‌های منحصر به فرد باتری واریان 74 آمپر</h3>
<p>این مدل از باتری‌های واریان با آمپر بالاتر (74Ah) و ولتاژ 12 ولت، محصولی کارآمد برای خودروهای پر مصرف است:</p>

<ul>
  <li>طراحی اتمی سیلد (MF) بدون نیاز به نگهداری</li>
  <li>مقاومت استثنایی در برابر لرزش‌های مداوم</li>
  <li>قدرت استارت‌زنی 520 آمپری در هوای سرد</li>
  <li>ظرفیت ذخیره‌سازی 135 دقیقه‌ای</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر مفید حدود 2 سال یا 40 هزار کیلومتر</li>
</ul>

<h3>مشخصات فنی و ابعاد</h3>
<p>این باتری با ابعاد 276×175×190 میلی‌متر و وزن 18.2 کیلوگرم (با الکترولیت) طراحی شده است:</p>
<ul>
  <li>ولتاژ اسمی: 12 ولت</li>
  <li>وزن خشک: 12.8 کیلوگرم</li>
  <li>جنس صفحات: سربی پره‌ای شبکه‌ای</li>
  <li>گارانتی: 12 ماه ضمانت رسمی از تاریخ تولید</li>
</ul>

<h3>خودروهای سازگار</h3>
<p>باتری 74 آمپر واریان برای خودروهای زیر مناسب است:</p>
<ul>
  <li>پژو 405</li>
  <li>سمند EF7</li>
  <li>رنو</li>
  <li>بنز مگان</li>
  <li>نیسان و ماکسیما</li>
  <li>و سایر خودروهای متوسط</li>
</ul>

<p>برای خرید باتری 74 آمپر واریان با گارانتی معتبر و قیمت مناسب، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره تخصصی هستند.</p>`,
    price: 3350000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 74Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 276×175×190 میلی‌متر</li>
<li><strong>وزن با الکترولیت:</strong> 18.2 کیلوگرم</li>
<li><strong>وزن خشک:</strong> 12.8 کیلوگرم</li>
<li><strong>قدرت استارت سرد:</strong> 520 آمپر</li>
<li><strong>ظرفیت ذخیره:</strong> 135 دقیقه</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
</ul>`,
    id: 1015,
    meta: {
      title: "خرید باتری 74 آمپر واریان | قیمت روز با گارانتی | باتری۱۰۰",
      description:
        "باتری 74 آمپر واریان با قدرت استارت‌زنی 520 آمپر، مناسب خودروهای متوسط و نیمه سنگین. گارانتی 12 ماهه.",
      keywords:
        "باتری 74 آمپر, باتری خودروهای متوسط, قیمت باتری واریان, باتری اتمی سیلد",
    },
  },
  {
    name: " باتری واریان صبا 90 آمپر (ناموجود)(Varian 90) ",
    slug: "battery-90ah-saba-varian",

    image: [p110, p111],
    info: `<h2>خرید و قیمت باتری 90 آمپر صبا واریان</h2>
<p> 90 آمپر واریان از تولیدات باکیفیت شرکت صبا باتری، قدیمی‌ترین و معتبرترین تولیدکننده باتری خودرو است. این محصول با قیمت مناسب و کارایی بالا، گزینه‌ای ایده‌آل برای خودروهای سواری و نیمه‌سنگین محسوب می‌شود.</p>

<h3>ویژگی‌های منحصر به فرد باتری واریان 90 آمپر</h3>
<p>این مدل از باتری‌های واریان با توجه به ظرفیت 90 آمپر ساعتی خود، مزایای قابل توجهی دارد:</p>

<ul>
  <li>قیمت بسیار مناسب نسبت به کیفیت ارائه شده</li>
  <li>طراحی اتمی سیلد بدون نیاز به نگهداری</li>
  <li>مقاومت بالا در برابر لرزش و ضربه</li>
  <li>عملکرد مطلوب در دمای پایین و استارت‌زنی قوی</li>
  <li>طول عمر بالا و بازدهی قابل توجه</li>
  <li>گارانتی 12 ماهه معتبر از شرکت صبا باتری</li>
</ul>

<h3>کاربردهای باتری واریان 90 آمپر</h3>
<p>این محصول برای خودروهای متنوعی مناسب است از جمله:</p>
<p>بی‌ام‌دبلیو X3، مینی‌بوس، خاور، هیوندایی، مرسدس بنز، ایسوزو، فوتون، دانگ فنگ و بسیاری از خودروهای سواری و نیمه‌سنگین دیگر.</p>

<p> واریان 90 آمپر با وجود قیمت مناسب، کیفیتی در سطح برترین باتری‌ها دارد و انتخاب هوشمندانه‌ای برای رانندگانی است که به دنبال محصولی با ارزش خرید بالا هستند.</p>

<p>برای خرید باتری 90 آمپر واریان با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره تخصصی برای انتخاب بهترین باتری متناسب با نیاز خودروی شما هستند.</p>`,
    price: 3850000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 90Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 353×175×190 میلی‌متر</li>
<li><strong>وزن:</strong> 22.5 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
<li><strong>ویژگی خاص:</strong> مقاوم در برابر لرزش و ضربه</li>
</ul>`,
    id: 1016,
    meta: {
      title: "باتری 90 آمپر واریان | قیمت با گارانتی 12 ماهه | باتری۱۰۰",
      description:
        "باتری 90 آمپر واریان مناسب خودروهای سنگین و ماشین‌آلات صنعتی. کیفیت بالا با قیمت مناسب.",
      keywords:
        "باتری 90 آمپر, باتری خودروهای سنگین, قیمت باتری واریان, باتری ماشین آلات",
    },
  },
  {
    name: "باتری واریان صبا 100 آمپر (ناموجود)(Varian 100) ",
    slug: "battery-100ah-saba-varian",

    image: [p120, p121],
    info: `<h2>خرید و قیمت باتری 100 آمپر صبا واریان</h2>
<p> خودرو 100 آمپر واریان از تولیدات باکیفیت شرکت صبا باتری، قدیمی‌ترین و معتبرترین تولیدکننده باتری خودرو است. این محصول با قیمت مناسب و کارایی بالا به یکی از پرفروش‌ترین باتری‌های بازار تبدیل شده است.</p>

<h3>ویژگی‌های منحصر به فرد باتری واریان 100 آمپر</h3>
<p>این مدل از باتری‌های صبا واریان با توجه به ظرفیت و کیفیت ساخت، گزینه‌ای ایده‌آل برای خودروهای مختلف محسوب می‌شود:</p>

<ul>
  <li>تکنولوژی اتمی سیلد بدون نیاز به نگهداری</li>
  <li>قیمت بسیار مناسب نسبت به کیفیت ارائه شده</li>
  <li>مقاومت بالا در برابر لرزش و ضربه</li>
  <li>عملکرد مطلوب در دمای بالا و پایین</li>
  <li>طول عمر مفید و بازدهی بالا</li>
  <li>گارانتی 12 ماهه شرکتی</li>
</ul>

<h3>مشخصات فنی و کاربردها</h3>
<p>باتری واریان 100 آمپر برای خودروهای مختلفی از جمله:</p>
<ul>
  <li>بی‌ام‌دبلیو X3</li>
  <li>هیوندایی</li>
  <li>مرسدس بنز</li>
  <li>مینی‌بوس‌های سبک</li>
  <li>خاور</li>
  <li>ایسوزو</li>
  <li>فوتون</li>
</ul>
<p>مناسب است. این باتری برای خودروهایی که سیستم‌های برقی پیچیده ندارند، انتخاب اقتصادی و مناسبی محسوب می‌شود.</p>

<p>برای خرید باتری 100 آمپر واریان با گارانتی معتبر و قیمت مناسب، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره رایگان برای انتخاب بهترین باتری متناسب با نیاز خودروی شما هستند.</p>`,
    price: 3900000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 100Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 353×175×190 میلی‌متر</li>
<li><strong>وزن:</strong> 22.5 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
<li><strong>ویژگی‌های خاص:</strong> مقاوم در برابر لرزش، عملکرد عالی در دمای مختلف</li>
</ul>`,
    id: 1017,
    meta: {
      title: "خرید باتری 100 آمپر واریان | قیمت ویژه با گارانتی | باتری۱۰۰",
      description:
        "باتری 100 آمپر واریان با گارانتی 12 ماهه، مناسب خودروهای سنگین و مینی‌بوس. مقاوم در برابر لرزش.",
      keywords:
        "باتری 100 آمپر, باتری خودروهای سنگین, قیمت باتری واریان, باتری مینی بوس",
    },
  },
  {
    name: "باتری واریان صبا 120 آمپر (ناموجود)(Varian 120) ",
    slug: "battery-120ah-saba-varian",

    image: [p130, p131],
    info: `<h2>خرید و قیمت باتری 120 آمپر واریان صبا باتری</h2>
<p>باتری 120 آمپر واریان از تولیدات باکیفیت شرکت صبا باتری با 12 ماه گارانتی رسمی، گزینه‌ای اقتصادی و مطمئن برای خودروهای سنگین و نیمه سنگین است. این محصول با تکنولوژی سیلد (اتمی) و کیفیت ساخت مطلوب، عملکردی پایدار و ایمن ارائه می‌دهد.</p>

<h3>ویژگی‌های برتر باتری واریان 120 آمپر</h3>
<p>این مدل از باتری خودرو با ظرفیت بالا و طراحی پیشرفته، مزایای قابل توجهی دارد:</p>

<ul>
  <li>گارانتی 12 ماهه شرکتی از صبا باتری</li>
  <li>مقاومت عالی در برابر لرزش و ضربه‌های مداوم</li>
  <li>عملکرد مطلوب در دمای بالا و پایین</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>طول عمر متوسط 1.5 تا 2 سال در شرایط نگهداری مناسب</li>
  <li>قیمت اقتصادی نسبت به سایر برندهای مشابه</li>
</ul>

<h3>مشخصات فنی و نکات مهم</h3>
<p>باتری واریان 120 آمپر با ابعاد استاندارد و وزن مناسب، برای انواع خودروهای سنگین طراحی شده است. عوامل زیر بر قیمت نهایی این محصول تأثیرگذارند:</p>
<ul>
  <li>تحویل باتری فرسوده توسط مشتری (تخفیف در قیمت)</li>
  <li>تاریخ تولید باتری</li>
  <li>خدمات جانبی ارائه شده</li>
</ul>

<p>این مدل باتری برای خودروهای سنگین و نیمه سنگین مناسب است. قیمت باتری 120 آمپر واریان با توجه به سیاست‌های کارخانه صبا باتری و شرایط ذکر شده محاسبه می‌گردد.</p>

<h3>نکات گارانتی و نگهداری</h3>
<p>موارد زیر باعث خروج باتری از گارانتی می‌شوند:</p>
<ul>
  <li>شارژ بیش از حد توسط دینام معیوب</li>
  <li>تخریب صفحات داخلی</li>
  <li>نشت اسید یا تغییر شکل بدنه</li>
  <li>سولفاته شدن صفحات</li>
</ul>

<p>برای خرید باتری 120 آمپر واریان با گارانتی معتبر و قیمت مناسب، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره فنی و راهنمایی برای انتخاب بهترین باتری متناسب با نیاز خودروی شما هستند.</p>`,
    price: 5050000,
    infos: `<ul>
<li><strong>نوع:</strong> سیلد (اتمی)</li>
<li><strong>آمپر ساعت:</strong> 120Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>عمر مفید:</strong> 1.5 تا 2 سال (در شرایط نگهداری مناسب)</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
<li><strong>ویژگی خاص:</strong> مقاوم در برابر لرزش و ضربه</li>
</ul>`,
    id: 1018,
    meta: {
      title: "باتری 120 آمپر واریان | قیمت با گارانتی 12 ماهه | باتری۱۰۰",
      description:
        "باتری 120 آمپر واریان با گارانتی 12 ماهه، مناسب کامیون‌ها و خودروهای سنگین. کیفیت تضمینی.",
      keywords: "باتری 120 آمپر, باتری کامیون, قیمت باتری سنگین, باتری واریان",
    },
  },
  {
    name: " باتری واریان صبا 150 آمپر (ناموجود)(Varian 150) ",
    slug: "battery-150ah-saba-varian",
    image: [p140, p141, p142],
    info: `<h2>خرید و قیمت باتری 150 آمپر صبا واریان</h2>
<p>باتری 150 آمپر واریان از تولیدات باکیفیت شرکت صبا باتری است که با قیمت مناسب و گارانتی معتبر عرضه می‌شود. این محصول با تکنولوژی سیلد (اتمی) تولید شده و گزینه‌ای ایده‌آل برای خودروهای سنگین و نیمه سنگین محسوب می‌شود.</p>

<h3>ویژگی‌های فنی باتری واریان 150 آمپر</h3>
<p>این مدل از باتری خودرو با مشخصات زیر تولید می‌شود:</p>

<ul>
  <li>نوع: سیلد (اتمی) بدون نیاز به نگهداری</li>
  <li>آمپر ساعت: 150Ah</li>
  <li>ولتاژ: 12 ولت</li>
  <li>ابعاد: متناسب با خودروهای سنگین</li>
  <li>گارانتی: 12 ماه ضمانت رسمی</li>
</ul>

<h3>عوامل موثر بر قیمت باتری 150 آمپر</h3>
<p>قیمت این محصول بر اساس موارد زیر تعیین می‌شود:</p>
<ul>
  <li>نرخ تعیین شده توسط کارخانه صبا باتری</li>
  <li>تحویل یا عدم تحویل باتری فرسوده</li>
  <li>تاریخ تولید محصول</li>
  <li>خدمات جانبی ارائه شده</li>
</ul>

<h3>طول عمر و نکات نگهداری</h3>
<p>عمر مفید این باتری در شرایط عادی 1 تا 2 سال است که به عوامل زیر بستگی دارد:</p>
<ul>
  <li>سلامت سیستم برق خودرو (دینام)</li>
  <li>شرایط آب و هوایی</li>
  <li>میزان استفاده از خودرو</li>
  <li>نحوه نگهداری و شارژ به موقع</li>
</ul>

<h3>نکات مهم گارانتی</h3>
<p>مواردی که باعث خروج باتری از گارانتی می‌شود:</p>
<ul>
  <li>تخریب صفحات داخلی</li>
  <li>نشتی اسید در اثر شارژ بیش از حد</li>
  <li>آسیب فیزیکی به بدنه یا قطب‌ها</li>
  <li>سولفاته شدن صفحات</li>
</ul>

<p>برای استعلام دقیق قیمت و خرید باتری 150 آمپر واریان با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره تخصصی هستند.</p>`,
    price: 6200000,
    infos: `<ul>
<li><strong>نوع:</strong> سیلد (اتمی)</li>
<li><strong>آمپر ساعت:</strong> 150Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
<li><strong>نکته:</strong> قیمت با احتساب تحویل باتری فرسوده محاسبه می‌شود</li>
</ul>`,
    id: 1019,
    meta: {
      title: "خرید باتری 150 آمپر واریان | قیمت استثنایی | باتری۱۰۰",
      description:
        "باتری 150 آمپر واریان مناسب خودروهای سنگین و ماشین‌آلات صنعتی. گارانتی 12 ماهه و کیفیت بالا.",
      keywords:
        "باتری 150 آمپر, باتری تراکتور, قیمت باتری سنگین, باتری ماشین آلات",
    },
  },
  {
    name: " باتری واریان صبا 170 آمپر (ناموجود)(Varian 170) ",
    slug: "battery-170ah-saba-varian",

    image: [p150, p151],
    info: `<h2>خرید و قیمت باتری 170 آمپر صبا واریان</h2>
<p> 170 آمپر واریان از تولیدات باکیفیت شرکت صبا باتری، قدیمی‌ترین و معتبرترین تولیدکننده باتری خودرو است. این محصول با قیمت مناسب و کارایی بالا، گزینه‌ای ایده‌آل برای خودروهای سنگین و ماشین‌آلات صنعتی محسوب می‌شود.</p>

<h3>ویژگی‌های منحصر به فرد باتری واریان 170 آمپر</h3>
<p>این مدل از باتری‌های سیلد واریان با توجه به ظرفیت بالا و کیفیت ساخت ممتاز، مزایای قابل توجهی دارد:</p>

<ul>
  <li>قدرت استارت‌زنی فوق‌العاده برای خودروهای سنگین</li>
  <li>مقاومت استثنایی در برابر لرزش و ضربات شدید</li>
  <li>عملکرد مطلوب در دمای بالا و پایین</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر طولانی با حداقل نیاز به نگهداری</li>
</ul>

<h3>مشخصات فنی و کاربردها</h3>
<p>باتری واریان 170 آمپر با طراحی اتمی سیلد، مناسب برای انواع خودروهای سنگین و ماشین‌آلات صنعتی شامل:</p>
<ul>
  <li>کامیون‌ها و کامیونت‌ها</li>
  <li>تریلی‌ها و خودروهای باری</li>
  <li>ماشین‌آلات کشاورزی (تراکتور، کمباین)</li>
  <li>خودروهای سنگین مانند ولوو، اسکانیا، رنو</li>
</ul>

<p>این محصول با گارانتی 12 ماهه شرکت صبا باتری عرضه می‌شود که نشان‌دهنده اعتماد سازنده به کیفیت آن است. قیمت باتری واریان 170 آمپر با توجه به ظرفیت و کیفیت ساخت، کاملاً اقتصادی و مقرون‌به‌صرفه می‌باشد.</p>

<p>برای خرید باتری 170 آمپر واریان با کیفیت تضمینی، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره تخصصی برای انتخاب بهترین باتری متناسب با نیاز خودرو یا ماشین‌آلات صنعتی شما هستند.</p>`,
    price: 7000000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 170Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 513×189×223 میلی‌متر</li>
<li><strong>وزن:</strong> 44 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
<li><strong>کاربرد:</strong> خودروهای سنگین و ماشین‌آلات صنعتی</li>
</ul>`,
    id: 1020,
    meta: {
      title: "باتری 170 آمپر واریان | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 170 آمپر واریان برای خودروهای سنگین و ماشین‌آلات صنعتی. مقاوم در برابر لرزش و ضربه.",
      keywords:
        "باتری 170 آمپر, باتری خودروهای سنگین, قیمت باتری ولوو, باتری اسکانیا",
    },
  },
  {
    name: "باتری واریان صبا 190 آمپر (ناموجود)(Varian 190) ",
    slug: "battery-190ah-saba-varian",

    image: [p160],
    info: `<h2>خرید و قیمت باتری 190 آمپر صبا واریان</h2>
<p>باتری 190 آمپر واریان از تولیدات باکیفیت شرکت صبا باتری با 40 سال سابقه درخشان در صنعت باتری‌سازی است. این محصول با تکنولوژی روز و گارانتی 12 ماهه، گزینه‌ای ایده‌آل برای خودروهای نیمه سنگین و ماشین‌آلات صنعتی محسوب می‌شود.</p>

<h3>ویژگی‌های منحصر به فرد باتری واریان 190 آمپر</h3>
<p>این مدل از باتری‌های اتمی سیلد با قدرت استارت‌زنی بالا و طول عمر طولانی، نیاز خودروهای سنگین را به خوبی برطرف می‌کند:</p>

<ul>
  <li>طراحی اتمی سیلد بدون نیاز به نگهداری</li>
  <li>مقاومت استثنایی در برابر لرزش‌های شدید</li>
  <li>عملکرد بی‌نظیر در دمای پایین (تا -30 درجه سانتیگراد)</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر مفید بالا با قابلیت شارژ مجدد</li>
</ul>

<h3>مشخصات فنی محصول</h3>
<p>باتری واریان 190 آمپر با ابعاد 500×220×224 میلی‌متر و وزن 46 کیلوگرم، برای نصب در خودروهای سنگین طراحی شده است. این محصول با آمپر بالا (190Ah) و ولتاژ 12 ولت، انرژی مورد نیاز وسایل نقلیه سنگین را تأمین می‌کند.</p>

<p>این مدل برای خودروهای ایسوزو، ولوو (FH, F12, N10, N12)، اسکانیا، رنو و همچنین ماشین‌آلات کشاورزی مانند تراکتور، دانگ فنگ و دیگر تجهیزات صنعتی کاملاً مناسب است. قیمت این باتری با توجه به کیفیت ساخت و گارانتی معتبر آن، بسیار مقرون‌به‌صرفه می‌باشد.</p>

<p>  برای خرید باتری 190 آمپر واریان با کیفیت تضمینی، می‌توانید به باتری۱۰۰ مراجعه نمایید.</p>`,
    price: 8000000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 190Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 500×220×224 میلی‌متر</li>
<li><strong>وزن:</strong> 46 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
<li><strong>ویژگی‌های خاص:</strong> مقاوم در برابر لرزش، عملکرد عالی در سرما، فیلتر ضد انفجار</li>
</ul>`,
    id: 1021,
    meta: {
      title: "خرید باتری 190 آمپر واریان | قیمت ویژه | باتری۱۰۰",
      description:
        "باتری 190 آمپر واریان با گارانتی 12 ماهه، مناسب خودروهای ایسوزو، ولوو و اسکانیا. کیفیت تضمینی.",
      keywords: "باتری 190 آمپر, باتری ایسوزو, قیمت باتری سنگین, باتری ولوو",
    },
  },
  // {
  //   name: "Armo-55",
  //   image: [pmain],
  //   info: "باطری صبا 50 آمپر مناسب تمامی خودرو ها",
  //   price: 2500000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 17,
  // },
  // {
  //   name: "Armo-60",
  //   image: [pmain],
  //   info: "باطری صبا 55 آمپر مناسب تمامی خودرو ها",
  //   price: 2720000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 18,
  // },
  // {
  //   name: "Armo-66",
  //   image: [pmain],
  //   info: "باطری صبا 60 آمپر مناسب تمامی خودرو ها",
  //   price: 2920000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 19,
  // },
  // {
  //   name: "Armo-70",
  //   image: [pmain],
  //   info: "باطری صبا 65 آمپر مناسب تمامی خودرو ها",
  //   price: 2950000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 20,
  // },
  // {
  //   name: "Armo-74",
  //   image: [pmain],
  //   info: "باطری صبا 70 آمپر مناسب تمامی خودرو ها",
  //   price: 3250000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 21,
  // },
  // {
  //   name: "Armo-88",
  //   image: [pmain],
  //   info: "باطری صبا 75 آمپر مناسب تمامی خودرو ها",
  //   price: 3560000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 22,
  // },
  // {
  //   name: "Armo-90",
  //   image: [pmain],
  //   info: "باطری صبا 80 آمپر مناسب تمامی خودرو ها",
  //   price: 3450000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 23,
  // },
  // {
  //   name: "Armo-100",
  //   image: [pmain],
  //   info: "باطری صبا 85 آمپر مناسب تمامی خودرو ها",
  //   price: 4320000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 24,
  // },
  // {
  //   name: "Armo-120N",
  //   image: [pmain],
  //   info: "باطری صبا 50 آمپر مناسب تمامی خودرو ها",
  //   price: 5150000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 25,
  // },
  // {
  //   name: "Armo-120",
  //   image: [pmain],
  //   info: "باطری صبا 55 آمپر مناسب تمامی خودرو ها",
  //   price: 4500000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 26,
  // },
  // {
  //   name: "Armo-150",
  //   image: [pmain],
  //   info: "باطری صبا 60 آمپر مناسب تمامی خودرو ها",
  //   price: 6100000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 27,
  // },
  // {
  //   name: "Armo-170",
  //   image: [pmain],
  //   info: "باطری صبا 65 آمپر مناسب تمامی خودرو ها",
  //   price: 6900000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 28,
  // },
  // {
  //   name: "Armo-200",
  //   image: [pmain],
  //   info: "باطری صبا 70 آمپر مناسب تمامی خودرو ها",
  //   price: 7800000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 29,
  // },
  // {
  //   name: "Armo-7",
  //   image: [pmain],
  //   info: "باطری صبا 75 آمپر مناسب تمامی خودرو ها",
  //   price: 1250000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 30,
  // },
  // {
  //   name: "Armo-9",
  //   image: [pmain],
  //   info: "باطری صبا 80 آمپر مناسب تمامی خودرو ها",
  //   price: 1500000,
  //   infos: "قیمت باطری با تحویل داغی محاسبه میشود",
  //   id: 31,
  // },
];
//
// اسکیما مارکاپ برای محصولات
const productSchema = (product) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: product.name,
  image: product.image[0],
  description: product.meta.description,
  brand: {
    "@type": "Brand",
    name: "صبا باتری",
  },
  offers: {
    "@type": "Offer",
    price: product.price,
    priceCurrency: "IRR",
    availability: "https://schema.org/InStock",
  },
});

export const ProductsContext = React.createContext();

const ProductContextProvider = ({ children }) => {
  return (
    <ProductsContext.Provider value={{ products: productsData }}>
      {children}
    </ProductsContext.Provider>
  );
};
export default ProductContextProvider;
